var _defs, _polygon, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGtoGrn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 548.48 475.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #5aad46;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "274.69 238.76 275 238.56 274.68 238.39 274.69 238.76"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M364.74,394.35h84.93l-42.38,73.61h-84.93l42.38-73.61ZM8.31,237.69l42.47-73.56,42.56,73.51-42.47,73.56L8.31,237.69ZM271.84,235.81l37.43-71.66-76.79-.2L141.28,7.37h84.93l91.32,156.81h-.14l-38.64,73.98,42.07,65.79,38.48-66.26h180.86s-42.47,73.54-42.47,73.54h-181.11l.16-.27-43.45-67.96-79.92,1.59,38.24,66.62-90.17,156.61-42.47-73.56,90.27-156.75v-.04s.02,0,.02,0v-.02s.02.02.02.02l82.55-1.64ZM322.43,7.3l84.94-.1,42.47,73.55-84.94.1L322.43,7.3ZM318.28,0l-44,76.21L232.45,3.77l-2.08-3.6h-93.25l-2.08,3.6-42.47,73.56-2.08,3.6,2.08,3.6,41.79,72.38H46.62l-2.08,3.6L2.08,234.06l-2.08,3.6,2.08,3.6,42.47,73.56,2.08,3.6h87.81l-41.7,72.22-2.08,3.6,2.08,3.6,42.47,73.56,2.08,3.6h93.25l2.08-3.6,41.66-72.16,41.76,72.33,2.08,3.6h93.25l2.08-3.6,42.47-73.56,2.08-3.6-2.08-3.6-41.79-72.39h87.74l2.08-3.6,42.47-73.56,2.08-3.6-2.08-3.6-42.47-73.56-2.08-3.6h-87.66l41.89-72.55,2.08-3.6-2.08-3.6L413.61,3.6l-2.08-3.6h-93.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M441.31,0v2.41h5.55v16.34h2.55V2.41h5.55V0h-13.65ZM472.17,0l-5.59,15.01-5.59-15.01h-3.18v18.75h2.55V3.98l5.31,14.77h1.82l5.31-14.52v14.52h2.52V0h-3.14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGtoGrn);
export default __webpack_public_path__ + "static/media/GTO_GRN.2b8a587a531d679ee49a3940143b315a.svg";
export { ForwardRef as ReactComponent };